import React from 'react';
import PropTypes from 'prop-types';

import styles from './PeriodSelector.css';

import { displayShortDate } from '../../utils/Format/Format';

const PeriodSelector = ({
    data,
    selectedPeriod,
    selectedDate,
    handleChange,
    customClassName,
    checkData = true
}) => (
    <div>
        {selectedPeriod === 'month' ? (
            <div
                className={
                    customClassName
                        ? `${customClassName} date-selector`
                        : 'selector'
                }
            >
                As of&nbsp;
                <select onChange={handleChange} value={selectedDate}>
                    {data.map((ele, index) => (
                        <option
                            value={ele.value}
                            disabled={checkData && !ele.hasData}
                            key={ele.label}
                            id={`date-option-${index}`}
                        >
                            {ele.label}
                        </option>
                    ))}
                </select>
            </div>
        ) : (
            `Quarterly (as of ${displayShortDate(selectedDate)})`
        )}
        <style jsx>{styles}</style>
    </div>
);

PeriodSelector.defaultProps = {
    data: [],
    handleChange: () => {},
    selectedPeriod: 'month',
    selectedDate: ''
};

PeriodSelector.propTypes = {
    /**
     * Data elements to represent in the legend
     */
    data: PropTypes.instanceOf(Array),
    selectedPeriod: PropTypes.string,
    selectedDate: PropTypes.string,
    /**
     * change event callback
     */
    handleChange: PropTypes.func
};

export default PeriodSelector;
